import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface FeedItemTitleMenuOption {
  label: string;
  action: (item: any) => void;
}

@Component({
  selector: 'app-feed-item-title',
  standalone: false,
  templateUrl: './feed-item-title.component.html',
  styleUrls: ['./feed-item-title.component.scss'],
})
export class FeedItemTitleComponent {
  @Input() iconName: string;
  @Input() title: string;
  @Input() link: string;
  @Input() feedItem: any;
  @Input() menuOptions: FeedItemTitleMenuOption[];
  @Input() showMenuOptions: boolean;
  @Output() itemClicked: EventEmitter<any> = new EventEmitter();
}
